// extracted by mini-css-extract-plugin
export default {"layout":"FavoritesTable_layout__RP32k"};